import { Column } from '@repo/ui/data-table'

type AffectedStaffSeniorityRow = {
  totalJourneys?: number | null
}

export function createAffectedStaffSeniorityColumn<
  TData extends AffectedStaffSeniorityRow,
  TExtra extends object = object
>(options?: Partial<Column<TData>> & TExtra): Column<TData> & TExtra {
  return {
    header: 'Ancienneté',
    accessorKey: 'totalJourneys',
    enableSorting: true,
    cell: ({ row }) => row.original.totalJourneys ?? '-',
    ...options
  } as Column<TData> & TExtra
}
